// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import promise from "es6-promise";
promise.polyfill();
import "babel-polyfill";
import App from "./App";
import Vue from "vue";
import "./assets/common.css";
import "normalize.css";
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from "vue-awesome-swiper";
// VueAMap.initAMapApiLoader({
//   // 高德key
//   key: '990e359476ab17682df02f8482266d1e',
//   // 插件集合 （插件按需引入）
//   plugin: ['AMap.RangingTool','AMap.CustomLayer', 'AMap.Scale', 'AMap.ToolBar', 'AMap.MapType', 'AMap.MarkerClusterer',"AMap.DistrictSearch"],
//   v: '1.4.4'
// });
import VueRouter from "vue-router";
Vue.use(VueRouter);
Vue.use(VueAwesomeSwiper)
import routes from "./router";

import axios from "axios";
Vue.prototype.axios = axios;

import ElementUI from "element-ui";
Vue.use(ElementUI);

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history",
  strict: process.env.NODE_ENV !== "production",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  },
});

//在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config);
  });
});

var vue = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js